import React from 'react';
import API from '../../services/API';
import CustomStore from 'devextreme/data/custom_store';
import useStyles from '../styles/styles';
import {
  Column,
  DataGrid,
  Paging,
  Editing,
  MasterDetail,
} from 'devextreme-react/data-grid';
import usePermissions from '../../hooks/usePermissions';
import DetailTemplate from '../../components/ReportDetails';
import {
  BreadCrumbRender,
  onToolbarBreadCrumb,
  LoadPermissions,
} from '../../global';
import { Template } from 'devextreme-react/core/template';

const reports = new CustomStore({
  key: 'ReportId',
  load: async () => {
    const { data } = await API.sendRequest(`Report`, 'get');
    return data;
  },
  insert: async (data) => {
    await API.sendRequest(`Report`, 'post', data);
  },
  update: async (id, data) => {
    await API.sendRequest(`Report`, 'post', data);
  },
  remove: async (id) => {
    await API.sendRequest(`Report/${id}`, 'delete');
  },
});

const onRowUpdating = (options) => {
  options.newData = { ...options.oldData, ...options.newData };
};

const Report = () => {
  const classes = useStyles();

  /** *******************************
   * Access Control
   ******************************** */
  const ACL = usePermissions();
  while (ACL === undefined) {
    return <LoadPermissions>Loading permissions</LoadPermissions>;
  }
  if (!ACL.Admin) {
    return (
      <LoadPermissions>
        You don't have access to this page. For Administrators Only.
      </LoadPermissions>
    );
  }
  /** ****************************** */

  return (
    <div className={classes.divGridContainer}>
      <DataGrid
        id="gridContainer"
        dataSource={reports}
        // keyExpr={'ReportId'}
        allowColumnReordering
        onRowUpdating={onRowUpdating}
        showBorders
        rowAlternationEnabled
        focusedRowEnabled
        showRowLines
        headerFilter={{ visible: true }}
        filterPanel={{ visible: true }}
        filterRow={{ visible: true }}
        onToolbarPreparing={onToolbarBreadCrumb}
      >
        <Paging enabled={false} />
        <Editing
          useIcons
          mode="form"
          allowAdding={ACL.AddNew}
          allowUpdating={ACL.Update}
          allowDeleting={ACL.Delete}
        />

        <Column dataField="ReportName" caption="Report" />
        <Column dataField="ReportUrl" caption="Url" />
        <MasterDetail enabled component={DetailTemplate} />
        <Template name="breadCrumb" render={() => BreadCrumbRender(ACL)} />
      </DataGrid>
    </div>
  );
};

export default Report;
